import { FC } from "react";
import { Link } from "react-router-dom";
import BannerCard from "src/components/BannerCard/BannerCard";
import { SubMenuItem } from "src/constants/modules";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const MenuBannerCard: FC<{
  item: Pick<SubMenuItem, "key" | "label" | "icon" | "route">;
  isselected: boolean;
  onClick: () => void;
}> = ({ item, isselected, onClick }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`/${item.route}`}
      className={classNames(
        "cursor-pointer! h-full! flex w-full items-center gap-3 rounded-none p-4 px-4 transition-all duration-200",
        isselected ? "text-font-active! font-semibold" : "text-font-subtle!",
      )}
      onClick={onClick}
    >
      <span className="h-5 w-5 shrink-0">{item.icon}</span>
      <span className="font-semibold">{t(item.label)}</span>
    </Link>
  );
};

export default MenuBannerCard;
